'use client';

import { CommandProvider } from '@/features/command-palette';
import { TanstackQueryClientProvider } from '@/providers/query-provider';
import { ThemeProvider } from '@/providers/theme-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TanstackQueryClientProvider>
      <ThemeProvider>
        <CommandProvider>{children}</CommandProvider>
      </ThemeProvider>
    </TanstackQueryClientProvider>
  );
}
